import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=be1aa8ea&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be1aa8ea')) {
      api.createRecord('be1aa8ea', component.options)
    } else {
      api.reload('be1aa8ea', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=be1aa8ea&", function () {
      api.rerender('be1aa8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KB4MFKRMApW9/JS/comp/ErrorMessage.vue"
export default component.exports